export const emailPattern = "^[\\w!.%+\\-]+@[\\w\\-]+(?:\\.[\\w\\-]+)+$";
export const telPattern = "^[+]*[-\\s\\./0-9]*$";
